import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import appConfig from 'app.config'
import './Menu.scss'
import {
	avardaBranding,
	getBlackCompanyLogo,
	getWhiteCompanyLogo,
} from 'utils/logoHelper'

const Menu = () => {
	const { t } = useTranslation()

	return (
		<div id="menu" className="application-menu">
			<header>
				<div className="menu-container">
					<div className="header-container">
						<img
							src={
								// with the avarda branding we have a darker menu and should therefore use the white logo
								avardaBranding(appConfig.country.toLowerCase())
									? getWhiteCompanyLogo(
											appConfig.country.toLowerCase(),
										)
									: getBlackCompanyLogo(
											appConfig.country.toLowerCase(),
										)
							}
							className="img-responsive tfbank-logo-header"
							alt="logo"
						/>
						<div className="sign-out">
							{appConfig.country !== 'uk' && (
								<Link
									to="/logout"
									className="btn btn-outline-darkgray">
									{t('SignOut')}
								</Link>
							)}
						</div>
					</div>
				</div>
			</header>
		</div>
	)
}
export default Menu
